const ORIGIN_URL = 'https://api.drgangwal.com/';
//const ORIGIN_URL = 'https://doctor-appointmentapi.aleaspeaks.com/';
const DEMO_URL = 'http://localhost:8000/';

const  LIVE_URL  = ORIGIN_URL ;
export { LIVE_URL, DEMO_URL };